import { defineComponent as _defineComponent } from 'vue'
import {
  Heading,
  BaseText,
  Grid,
  ListDisplay
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { Money } from '@/modules/common/components/Money';

import { IPerformanceDetailResponse } from '@/modules/investments/services/investments';

interface Props {
  summaryDetails: IPerformanceDetailResponse;
  updatedAt: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PerformanceDetails',
  props: {
    summaryDetails: null,
    updatedAt: null
  },
  setup(__props: any) {



return { __sfc: true,Heading, BaseText, Grid, ListDisplay, NebraskaColors, Money }
}

})